/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const renameCustomerBodyExpectedCustomerVersionExclusiveMin = 0;
export const renameCustomerBodyExpectedCustomerVersionMax = 9007199254740991;

export const RenameCustomerBody = zod.object({
  name: zod.string(),
  expectedCustomerVersion: zod
    .int()
    .gt(renameCustomerBodyExpectedCustomerVersionExclusiveMin)
    .max(renameCustomerBodyExpectedCustomerVersionMax),
});

export type RenameCustomerBody = zod.input<typeof RenameCustomerBody>;
export type RenameCustomerBodyOutput = zod.output<typeof RenameCustomerBody>;
